<div class="title">FEEDBACK</div>
<mat-card class="lower-mat-card">
  <mat-form-field style="width: 100%;">
    <textarea
      matInput
      #feedbackText
      [attr.disabled]="disabled === true ? true : null"
      [(ngModel)]="feedback"
      name="feedback"
      placeholder="Have a new idea? Something not working? Let the FitForce Planner team know!"
    ></textarea>
  </mat-form-field>
</mat-card>
<div @fade class="alert-success" *ngIf="successMessage">Thank you for your feedback!</div>
<mat-error @fade *ngIf="!inputValid">The text should contain minimum 3 characters!</mat-error>
<mat-error @fade *ngIf="errorMessage">Something went wrong. Please try again.</mat-error>
<button (click)="submitFeedback(feedbackText.value)" mat-raised-button color="primary" [attr.disabled]="disabled === true ? true : null">
  SEND <i class="material-icons">send</i>
</button>
